import type { AccountInfo } from "@azure/msal-browser";
import { loginRequest, previewLoginRequest } from "@/authConfig";
import { AZURE_TENANT_ID } from "@/lib/env";

// Delivery signs in through `common`, but preview rights only exist for
// accounts of the internal tenant. Preview pages therefore sign in against that
// tenant only. Every other route stays multi-tenant.

const isPreviewPath = (path: string) => path.startsWith("/preview/");

// The cached account from the internal tenant, if this browser has one. MSAL lists
// one account per tenant the user has signed in to.
const findPreviewAccount = (accounts: AccountInfo[]) =>
  accounts.find((account) => account.tenantId === AZURE_TENANT_ID) ?? null;

// The account the page signs in with: on a preview only one from the internal
// tenant.
const accountForPath = (path: string, accounts: AccountInfo[]) =>
  isPreviewPath(path) ? findPreviewAccount(accounts) : (accounts[0] ?? null);

const loginRequestFor = (path: string) =>
  isPreviewPath(path) ? previewLoginRequest : loginRequest;

export { accountForPath, loginRequestFor };
